import { Link } from "react-router-dom";
import { WorkItem } from "../../pages/WorkItem/WorkItem";

import './workPagination.css';

type props = {
    currentWorkItem: WorkItem,
    workItems: WorkItem[]
}

export default function WorkPagination({ currentWorkItem, workItems }: props) {

    const prevWorkItem: WorkItem | undefined = workItems.find(w => w.id === (currentWorkItem.id - 1));
    const nextWorkItem: WorkItem | undefined = workItems.find(w => w.id === (currentWorkItem.id + 1));

    return (
        <div className="work-pagination">
            <div className="inner">
                <div className="buttons">
                    <Link to={(prevWorkItem !== undefined ? "/work/" + prevWorkItem.handle : "")} className={"btn" + (prevWorkItem === undefined ? " disabled" : "")}>Previous</Link>
                    <Link to={(nextWorkItem !== undefined ? "/work/" + nextWorkItem.handle : "")} className={"btn" + (nextWorkItem === undefined ? " disabled" : "")}>Next</Link>
                </div>
            </div>
        </div>
    );
}